








import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GSelectorEx',
  props: {
    value: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    reverse: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get(): boolean {
        return this.reverse ? !this.value : this.value;
      },
      set(val: boolean): void {
        this.$emit('input', this.reverse ? !val : val);
      },
    },
  },
});
